import React, { useEffect, useState } from 'react'
import './DiaryComponent.css'
import HeaderComponent, { HeaderWithoutLogin } from '../Header/HeaderComponent'
import FooterComponent from '../Footer/FooterComponent'

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    setIsLoggedIn(!!token); // Sets isLoggedIn to true if token exists, otherwise false
  }, []);

  return isLoggedIn ? <HeaderComponent /> : <HeaderWithoutLogin />;
}

const DiaryComponent = () => {
  return (
    <div className='flex flex-col min-h-screen container-innovador'>
      <Header />

      <div className='flex-grow w-full flex flex-col items-center p-4'>
        {/* Imagen para pantallas grandes */}
        <img
          src="./Fecha-Horario-actualizado-v2.png"
          className="hidden md:block lg:block xl:block md:w-[350px] lg:w-[450px] xl:w-[450px] mb-2"
          alt="fechas-evento"
        />
        {/* Imagen para pantallas pequeñas */}
        <img
          src="./Fecha-Horario-actualizado-v2.png"
          className="block md:hidden lg:hidden xl:hidden w-[300px] mb-2"
          alt="fechas-evento"
        />

        {/* Imagen de agenda */}
        <img
          src="./Agenda-actualizada-v2.png"
          className="mb-5 p-5"
          alt="agenda-evento"
        />
      </div>

      <FooterComponent />
    </div>
  )
}

export default DiaryComponent
